import { Component, Input, OnInit, ViewChild, TemplateRef, ViewContainerRef, Inject } from '@angular/core';
import { ControlBase } from '../../base/control-base/control-base.component';
import { HttpClient } from '@angular/common/http';
import { TRANSLATE_FILES_DIRECTORY__INJECTION_TOKEN } from 'angular-core-src';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
    selector: 'i18n-html-content-loader-control',
    templateUrl: './i18n-html-content-loader.control.html',
    standalone: false,
})
export class I18nHtmlContentLoaderControl extends ControlBase implements OnInit {
    constructor(
        private http: HttpClient,
        private viewContainerRef: ViewContainerRef,
        protected override spinnerService: NgxSpinnerService,
        @Inject(TRANSLATE_FILES_DIRECTORY__INJECTION_TOKEN)
        private translateFilesDirectory: string
    ) {
        super(spinnerService);
    }

    @Input()
    public filePostFix: string = '';

    @ViewChild(TemplateRef, { static: true })
    template: TemplateRef<unknown>;

    ngOnInit(): void {
        let currentLanguage: string = this.ioc.core.translation.getCurrentLanguage();
        let fileUrl: string = new URL(
            'ui_' + currentLanguage + '_' + this.filePostFix + '.html',
            window.location.origin + this.translateFilesDirectory
        ).toString();
        this.http.get(fileUrl, { responseType: 'text' }).subscribe((data: string): void => {
            let ctx: any = { htmlContent: data };
            this.viewContainerRef.createEmbeddedView(this.template, ctx);
        });
    }
}
